import { convertToFormData } from 'helper/convert_obj_to_form_data';
import client from './config'

//////////////// about_us ////////////////
const aboutUsUrl = 'about_us';
export const getAboutUsRequest = () => client.get(aboutUsUrl);

export const updateAboutUsRequest = (values, onUploadProgress) => {
    !values.image && delete values.image;
    return client.post(`${aboutUsUrl}`, convertToFormData(values), {
        onUploadProgress: (progress) =>
          onUploadProgress((progress.loaded / progress.total) * 100),
      });
}